export const ANBIMA_REPORT_FORM_TO_API_MAP = {
  codigo: 'codigo_anbima',
  statusCarteira: 'status_carteira',
  primeiroAporte: 'data_primeiro_aporte',
  encerramentoContrato: 'data_encerramento_contrato',
  modeloCarteira: 'modelo_carteira',
  segmentoInvestidor: 'segmento_investidor',
  publicoAlvo: 'publico_alvo',
  riscoCarteira: 'perfil_risco_carteira',
  riscoInvestidor: 'perfil_risco_investidor',
  creditoPrivado: 'permite_credito_privado',
  investimentoExterior: 'permite_investimento_exterior',
  investimentoCotasFundos: 'permite_investimento_cotas',
  derivativos: 'permite_derivativos',
  estrategiasDerivativos: 'estrategias_derivativos',
  tipoTaxaGestao: 'tipo_taxa_gestao',
  valorTaxaGestao: 'valor_taxa_gestao',
  descricaoTaxaGestao: 'descricao_taxa_gestao',
  cobrancaTaxaComplementar: 'cobranca_taxa_complementar',
  tipoCobrancaTaxaComplementar: 'tipo_taxa_complementar',
  valorTaxaComplementar: 'valor_taxa_complementar',
  descricaoTaxaComplementar: 'descricao_taxa_complementar',
  cobrancaTaxaPerformance: 'cobranca_taxa_performance',
  tipoCobrancaTaxaPerformance: 'tipo_taxa_performance',
  valorTaxaPerformance: 'valor_taxa_performance',
  descricaoTaxaPerformance: 'descricao_taxa_performance',
  utilizaBenchmark: 'utiliza_benchmark',
  benchmark: 'benchmark_aplicavel',
  custodianteContratado: 'custodiante_contratado',
  cnpjCustodianteContratado: 'cnpj_custodiante',
  controladorContratado: 'controlador_contratado',
  cnpjControlador: 'cnpj_controlador',
  aprecamentoCarteira: 'metodo_aprec_por',
  cnpjResponsavelAprecamento: 'cnpj_responsavel_aprec',
  rentabilidadeTir: 'rentabilidade_tir',
  aportes: 'aportes',
  resgates: 'resgates',
  volumeFinanceiro: 'volume_financeiro',
  valorAplicadoCotas: 'valor_vac',
  criptoativos: 'permite_criptoativos',
  campoApoio: 'campo_apoio',
}

export const ANBIMA_REPORT_API_TO_FORM_MAP = Object.fromEntries(
  Object.entries(ANBIMA_REPORT_FORM_TO_API_MAP).map(([key, value]) => [
    value,
    key,
  ])
)

export const ANBIMA_REPORT_OPTIONS = {
  statusCarteira: ['Ativa', 'Encerrada', 'Inativa'],
  modeloCarteira: ['Padronizada', 'Customizada'],
  segmentoInvestidor: [
    'EFPC Empresa Pública',
    'EFPC Empresa Privada',
    'Instituições Financeiras',
    'Seguradora',
    'EAPC',
    'Capitalização',
    'Corporate',
    'Middle Market',
    'Private',
    'Varejo Alta Renda',
    'Varejo',
    'Poder Público',
    'RPPS',
    'Investidor não residente',
  ],
  publicoAlvo: ['Profissional', 'Qualificado', 'Investidores em geral'],
  simNao: ['Sim', 'Não'],
  estrategiasDerivativos: ['Hedge', 'Alavancagem', 'Posicionamento'],
  tipoTaxaGestao: [
    'Fixa',
    'Percentual',
    'Específica',
    'Escalonada',
    'Não há cobrança de taxa de gestão',
  ],
  tipoCobrancaTaxa: ['Fixa', 'Percentual', 'Específica'],
  benchmark: [
    'CDI',
    'CDI 30 x 30',
    'Dolar Comercial',
    'DÓLAR PTAX',
    'EURO',
    'FTSE 100',
    'BDRX',
    'IBOVESPA',
    'IBOVESPA FECHAMENTO',
    'IBOVESPA Médio',
    'IBRA',
    'IBRX',
    'IBRX 100',
    'IBRX 50',
    'ICO2',
    'ICON',
    'IDA-DI',
    'IDA-GERAL',
    'IDA-IPCA',
    'IDIV-DIVIDENDOS',
    'IDKA PRÉ 1A',
    'IDKA PRÉ 2A',
    'IDKA PRÉ 3A',
    'IDKA PRÉ 3M',
    'IDKA PRÉ 5A',
    'IDKA-IPCA 15A',
    'IDKA-IPCA 20A',
    'IDKA-IPCA 10A',
    'IDKA-IPCA 2A',
    'IDKA-IPCA 30A',
    'IDKA-IPCA 3A',
    'IDKA-IPCA 5A',
    'IEE - ENERGIA',
    'IFIX',
    'IFMM',
    'IFNC',
    'IGC',
    'IGC-NM',
    'IGCT',
    'IGP-DI',
    'IGP-M',
    'IHFA',
    'IMA GERAL',
    'IMA-S',
    'IMA-B',
    'IMA-B5',
    'IMA-B5+',
    'IMAT',
    'IMOB-IMOBILIÁRIO',
    'INCC',
    'INDX',
    'INPC',
    'IPCA',
    'IRF-M',
    'IRF-M1',
    'IRF-M1+',
    'ISE',
    'ITAG',
    'IVBX',
    'IVBX-2',
    'MLCX',
    'NÃO SE APLICA',
    'OUTROS',
    'Poupança',
    'SELIC',
    'SELIC 30x30',
    'SMLL',
    'Taxa Referencial',
  ],
  aprecamentoCarteira: ['Terceiros', 'Própria'],
  criptoativos: ['Permite diretamente', 'Permite indiretamente', 'Não permite'],
}

export const ANBIMA_REPORT_LABELS = {
  selectedClient: 'Selecione um cliente já cadastrado',
  statusCarteira: 'Status da carteira',
  primeiroAporte: 'Primeiro aporte',
  encerramentoContrato: 'Encerramento contrato',
  modeloCarteira: 'Modelo de carteira',
  segmentoInvestidor: 'Segmento do investidor',
  publicoAlvo: 'Público alvo',
  riscoCarteira: 'Perfil de risco da carteira',
  riscoInvestidor: 'Perfil de risco do investidor',
  derivativos: 'Permite derivativos',
  estrategiasDerivativos: 'Estratégias permitidas com derivativos',
  tipoTaxaGestao: 'Tipo de taxa de gestão',
  valorTaxaGestao: 'Valor da taxa de gestão',
  descricaoTaxaGestao: 'Descrição de taxa de gestão',
  cobrancaTaxaComplementar: 'Cobrança de taxa complementar',
  tipoCobrancaTaxaComplementar: 'Tipo de cobrança de taxa complementar',
  valorTaxaComplementar: 'Valor da taxa complementar',
  descricaoTaxaComplementar: 'Descrição da taxa complementar',
  cobrancaTaxaPerformance: 'Cobrança de taxa de performance',
  tipoCobrancaTaxaPerformance: 'Tipo de cobrança de taxa de performance',
  valorTaxaPerformance: 'Valor da taxa de performance',
  descricaoTaxaPerformance: 'Descrição da taxa de performance',
  utilizaBenchmark: 'Utiliza benchmark',
  benchmark: 'Benchmark caso aplicável',
  custodianteContratado: 'Custodiante contratado',
  cnpjCustodianteContratado: 'CNPJ do custodiante contratado',
  controladorContratado: 'Controlador contratado',
  cnpjControlador: 'CNPJ do controlador contratado',
  aprecamentoCarteira: 'Apreçamento da carteira é realizado pelo:',
  cnpjResponsavelAprecamento: 'CNPJ do responsável pelo apreçamento',
  rentabilidadeTir: 'Rentabilidade/TIR',
  creditoPrivado: 'Permite crédito privado',
  investimentoExterior: 'Permite investimento no exterior',
  investimentoCotasFundos: 'Permite investimento em cotas de fundos próprios',
  aportes: 'Aportes',
  resgates: 'Resgates',
  volumeFinanceiro: 'Volume financeiro',
  valorAplicadoCotas: 'Valor aplicado em cotas de fundos (VAC)',
  criptoativos: 'Permite criptoativos',
}

export const CLIENT_STATUS_TOGGLE_OPTIONS = [
  { value: 'ativo', text: 'Ativo' },
  { value: 'inativo', text: 'Inativo' },
]

export const CLIENT_ACCESS_TOGGLE_OPTIONS = [
  { value: 'liberado', text: 'Liberado' },
  { value: 'bloqueado', text: 'Bloqueado' },
]
